export const SetTableOptions = 'tech-demo-1/tables/SET_TABLE_OPTIONS'

export default {
  SetTableOptions
}



// WEBPACK FOOTER //
// ./src/store/tables/action-type.js